<script>
import Layout from '@layouts/main'
import api from '@utils/api'
import Setting from './setting'

export default {
  name: 'Settings',
  components: { Setting, Layout },
  data() {
    return {
      modelName: 'settings',
      editItem: false,
      isLoading: false,
      headers: [
        { text: 'name', value: 'name', sortable: false },
        { text: 'value', value: 'value', sortable: false },
      ],
      currentItem: {},
      content: [],
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      this.isLoading = true
      api.getGlobalSettings().then(response => {
        this.content = response.content
      })
      this.isLoading = false
    },
    getValue(dictionaryName, value) {
      return this.$store.getters['data/getValueFromDictionary'](
        dictionaryName,
        value
      )
    },
    openItem(item) {
      this.currentItem = item
      this.editItem = true
    },
    closeItem() {
      this.currentItem = {}
      this.editItem = false
    },
    itemWasUpdated() {
      this.currentItem = {}
      this.editItem = false
      this.fetchData(this.params)
      this.$store.dispatch("globalSettings/load")
    },
  },
}
</script>

<template>
  <Layout>
    <v-data-table
      :headers="headers"
      :items="content"
      :loading="isLoading"
      :class="$style.sdTable"
      hide-actions
    >
      <template 
        slot="headers" 
        slot-scope="props">
        <tr>
          <th
            v-for="header in props.headers"
            :key="header.text"
            style="text-align: left"
          >
            {{ $t(`label__${header.text}`) }}
          </th>
        </tr>
      </template>
      <v-progress-linear
        slot="progress"
        height="2"
        color="blue"
        background-color="#E0E0E0"
        indeterminate
      />
      <template
        slot="items"
        slot-scope="props"
      >
        <tr
          :class="$style.sdEditRow"
          @click="openItem(props.item)">
          <td>{{ $t('label__'+ props.item.name) }}</td>
          <td>{{ props.item.value }}</td>
        </tr>
      </template>
    </v-data-table>
    <setting
      :dialog="editItem"
      :current-item="currentItem"
      @close-modal="closeItem"
      @item-updated="itemWasUpdated"/>
  </Layout>
</template>

<style lang="scss" module>
@import '@design';
.sdTable {
  border: 1px solid #dfdfdf;

  th {
    outline: none;
  }
}
.sdEditRow {
  cursor: pointer;
}
.sdBorder {
  border: 1px solid #dfdfdf;
  border-bottom: none;
}
</style>
